import React, {useCallback, useEffect, useState} from 'react';
import { Grid2, Typography ,Button, Box } from '@mui/material';
import { useMediaQuery, useTheme } from '@mui/material';
import DeleteIcon from '../../assets/Delete.svg';
// import { useLocation, useNavigate, useParams } from 'react-router-dom';
import Delete from '../../assets/delete-icon.svg';
import AppModal from '../Modal/AppModal';
import { useDelete, useGet } from '../../hooks/useApi';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDeleteGiftFavorite } from '../../hooks/useDeleteGiftFavorite';
import toast from 'react-hot-toast';
import { useDeleteCourseFavorite } from '../../hooks/useDeleteCourseFavorite';
// import ReusableDrawer from '../CheckoutSidebar/ReusableDrawer';
// import SidebarNav from '../CheckoutSidebar/SidebarNav';
// import SidebarForm from '../CheckoutSidebar/SidebarForm';
// import TabPanel from '../CheckoutSidebar/TabPanel';
// import { useWindowResize } from '../../hooks/useWindowResize';


const OrderCard = ({item, setOpenModal, image='', title='',description='',openModal,handleCheckoutGift,openGiftDrawer}) => {

  
  const navigate = useNavigate();
  const { data: validateCustomer} = useGet('/api/GiftItems/validate-Customer');
  const customerId = validateCustomer?.data.customerId
  const { deleteGiftFavorite } = useDeleteGiftFavorite();
  const {deleteCourseFavorite} = useDeleteCourseFavorite();
    const theme = useTheme();
    const isDesktop = useMediaQuery(theme.breakpoints.up('sm')); 
    // const {data: deleteGiftFavorite} = useDelete(`/api/GiftItems/favorites/${customerId}/${giftId}`)
    // console.log(deleteGiftFavorite);
    
    const {pathname} = useLocation()
    //  const {data: deleteCourse} = useDelete(`/api/Courses/favorites/2/2?courseId=2`)
    // /api/Courses/favorites/2/2?courseId=2
  //  const [openModal, setOpenModal] = useState(false)
  //  const navigate = useNavigate()
   const messageContent = {
       beforeSpan: "",
       spanContent: "",
       afterSpan: ""
     };

    
     const handleGiftDelete = async (id)=>{
 
      
      setOpenModal(true)
   
      try {
        await deleteGiftFavorite(customerId, id);
        setOpenModal(false)
       
        toast.success('Removed from favorites!', {
          position: "top-right"
        });
        window.location.reload();
        // Optionally refresh your favorites list here
      } catch (error) {
        toast.error('Failed to remove from favorites', {
          position: "top-right"
        });
      
   
         
             }}
    const handleCourseDelete = async (id)=>{

              setOpenModal(true)
         
            
              try {
                await deleteCourseFavorite(customerId, id);
                setOpenModal(false)
               
                toast.success('Removed from favorites!', {
                  position: "top-right"
                });
                window.location.reload();
                // Optionally refresh your favorites list here
              } catch (error) {
                toast.error('Failed to remove from favorites', {
                  position: "top-right"
                });
              
           
                 
                     }}
   const handleDelete = ()=>{

    setOpenModal(true)
      //  navigate('/product/giftshop')
           }
  
  const handleRemove = (itemId) => {
    console.log(itemId);
    
     setOpenModal(true)
    // Implement removal logic, e.g., filtering out the item


    
  };
  const handleOrderClick = ()=>{

  }
  if (isDesktop){
  return (
    <Grid2 container alignItems="center" spacing={{xs:0, md:2}} sx={{justifyContent:'space-between', my:3, backgroundColor:'rgba(255, 255, 255, 1)', border:'1px solid rgba(210, 209, 214, 1)', borderRadius:'20px', py:1, px:2}}>
    <Grid2 size={9} sx={{display:'flex', alignItems:'center', gap:2}}>
    {/* Item Image */}
    <Grid2 item size={3}>
      <img src={image} alt={item.name} style={{width:'100%', height:'120px'}}/>
    </Grid2>

    {/* Item Details */}
    <Grid2 item size={9}>
        <>
        <Box sx={{display:'flex', gap:2, alignItems:'center'}}>
        <Typography variant="body1" color='rgba(18, 18, 18, 1)' sx={{width:'50%', fontWeight:'600'}}>{title}</Typography>
        {item?.manufacturer && (
        <Typography
          sx={{
            backgroundColor: 'rgba(246, 167, 4, 1)',
            borderRadius: '8px',
            p: 1,
            textTransform: 'uppercase',
            width: 'fit-content',
            fontSize:'.8rem',
            // width:'50%',
            gap: 1,
            display:'flex',
            alignItems:'center',
            justifyContent:'center',
            my: {md: 2, xs: 1},
            textTransform:'unset'
          }}
        >
          {item.manufacturer?.image && (
            <img
              src={item.manufacturer?.image}
              alt="Category img"
              style={{ borderRadius: '50%', width: 16, height: 16 }}
            />
          )}
          <span style={{width:'90%', fontWeight:'600'}}>{item?.manufacturer }</span>
        </Typography>
      )}
        { item?.categoryName &&  <Typography
          sx={{
            backgroundColor: 'rgba(246, 167, 4, 1)',
            borderRadius: '8px',
            p: 1,
            textTransform: 'uppercase',
            width: 'fit-content',
            fontSize:'.8rem',
            // width:'50%',
            gap: 1,
            display:'flex',
            alignItems:'center',
            justifyContent:'center',
            my: {md: 2, xs: 1},
            textTransform:'unset'
          }}
        >
       
          <span style={{width:'90%', fontWeight:'600'}}>{item?.categoryName}</span>
        </Typography>}
      
      { item?.catgoryName &&  <Typography
          sx={{
            backgroundColor: 'rgba(246, 167, 4, 1)',
            borderRadius: '8px',
            p: 1,
            textTransform: 'uppercase',
            width: 'fit-content',
            fontSize:'.8rem',
            // width:'50%',
            gap: 1,
            display:'flex',
            alignItems:'center',
            justifyContent:'center',
            my: {md: 2, xs: 1},
            textTransform:'unset'
          }}
        >
       
          <span style={{width:'90%', fontWeight:'600'}}>{item?.catgoryName}</span>
        </Typography>}
     
        </Box>
      <Typography variant="body2" color='rgba(18, 18, 18, 0.8)' sx={{fontSize:'.8rem'}}>{description}</Typography>
      </>
      <Typography variant="body2" color="rgba(246, 167, 4, 1)" sx={{fontWeight:'700', fontSize:'1.25rem', my:1}}>
        {item.price}
      </Typography>
    </Grid2>
    </Grid2>

    {/* Remove Button */}
    <Grid2 item size={2} sx={{display:'flex', flexDirection:'column', alignItems:'end'}}>
      <Button
        color="error"
        size="small"
        onClick={() => handleRemove(item?.id)}
      >
        <img src={DeleteIcon} alt="delete" />
      </Button>
      { openGiftDrawer ?  <Box sx={{ marginTop: 2, width: 145}}>
    <Button
      variant="contained"
      color="success"
      // onClick={toggleDrawer(!sidebarstate)}
      onClick={handleCheckoutGift}
      sx={{
        width: '100%',
        padding: {md: '10px 20px', xs: '5px 8px'},
        borderRadius: '25px',
          textTransform:'capitalize',
          backgroundColor: '#5604F6',
          color:'#fff'
      }}
    >
      Order Now
    </Button>
  </Box> :  <Box sx={{ marginTop: 2, width: 145}}>
    <Button
      variant="contained"
      color="success"
      // onClick={toggleDrawer(!sidebarstate)}
      onClick={handleCheckoutGift}
      sx={{
        width: '100%',
        padding: {md: '10px 20px', xs: '5px 8px'},
        borderRadius: '25px',
          textTransform:'capitalize',
          backgroundColor: '#5604F6',
          color:'#fff'
      }}
    >
      Order Now
    </Button>
  </Box>}
  {openModal && <AppModal setShowModal={setOpenModal} showModal={true} icon={DeleteIcon}  message={messageContent}>
        <Typography variant='h3' sx={{color: 'rgba(18, 18, 18, 1)', fontSize: 20}}>
        Remove Item from favorites
            </Typography>
            <Typography variant='p' sx={{marginTop: 2}}>
            Are you sure you want to delete this item from your favorites list? This action cannot be undone.
            </Typography>
        <Box sx={{display:'flex', flex: 1, alignItems:'center', justifyContent: 'space-between', marginTop: {md: 4, xs: 2},marginBottom: {md: 0, xs: 2}, width: '100%', gap: 6}}>



{/* Add to Favorites Button  */}
<Box sx={{ marginTop: 1,width: 'auto' }}>
 <Button
 onClick={()=>setOpenModal(false)}
   variant="contained"
   color="secondary"
   sx={{
     width: '100%',
     
     padding: {md: '10px 20px', xs: '5px 8px'},
     border: '1px solid #CBB1FC',
     borderRadius: '25px',
    
     textTransform:'capitalize',
     backgroundColor:'rgba(219, 219, 219, 1)',
     color:'rgba(18, 18, 18, 0.7)',
    
  
   }}
 >
  Cancel
 </Button>
</Box>

{pathname.includes('giftshop') ? <Box sx={{ marginTop: 2, width: 'auto'}}>
 <Button
   variant="contained"
   color="success"
   onClick={()=>handleGiftDelete(item?.id)}
   sx={{
     width: '100%',
     padding: {md: '10px 20px', xs: '5px 8px'},
     borderRadius: '25px',
       textTransform:'capitalize',
       backgroundColor:'rgba(254, 86, 86, 1)',
     color:'#fff',
   }}
 >
  Yes, Remove Item
 </Button>
</Box> : <Box sx={{ marginTop: 2, width: 'auto'}}>
 <Button
   variant="contained"
   color="success"
   onClick={()=>handleCourseDelete(item?.courseId)}
   sx={{
     width: '100%',
     padding: {md: '10px 20px', xs: '5px 8px'},
     borderRadius: '25px',
       textTransform:'capitalize',
       backgroundColor:'rgba(254, 86, 86, 1)',
     color:'#fff',
   }}
 >
  Yes, Remove Item
 </Button>
</Box>}


</Box>
            
            </AppModal>}
      {/* <Button variant="contained"
                  sx={{width:'100%', my:3,display:'flex', alignItems:'center', gap:1, textTransform:'none', color:'rgba(255, 255, 255, 1)', boxShadow:'none', backgroundColor:'rgba(86, 4, 246, 1)', p:{xs:0, md:2}, minWidth:{xs:'', md:'fit-content'}, borderRadius:'100px', ':hover': {
            backgroundColor:'#4f03e7', 
            fontWeight:600,
            boxShadow:'0px 3px 1px -2px rgba(86, 4, 246,0.2),0px 2px 2px 0px rgba(86, 4, 246,0.14),0px 1px 5px 0px rgba(86, 4, 246,0.12)'
          }}}>Order Now</Button> */}
    </Grid2>
  </Grid2>
  )}
  else{
    return(
    <Box sx={{justifyContent:'space-between', my:3, backgroundColor:'rgba(255, 255, 255, 1)', border:'1px solid rgba(210, 209, 214, 1)', borderRadius:'20px', py:1, px:2}}>
        <Box sx={{display:'flex', justifyContent:'space-between'}}>
            <Box sx={{display:'flex', gap:2}}>
                {/* <img src={item?.images[1]} alt={item.name} style={{width:'80px', height:'60px'}}/> */}
                <Typography variant="body1" color='rgba(18, 18, 18, 1)' sx={{width:'50%'}}>{item.name}</Typography>
            </Box>
            <Button
                color="error"
                size="small"
                onClick={() => handleRemove(item.id)}
            >
                <img src={DeleteIcon} alt="delete" />
            </Button>
        </Box>
        <Typography variant="body2" color='rgba(18, 18, 18, 0.8)' sx={{fontSize:'.8rem'}}>{item.description}</Typography>
        <Box sx={{display:'flex', justifyContent:'space-between', alignItems:'center'}}>
            <Typography variant="body2" color="rgba(246, 167, 4, 1)" sx={{fontWeight:'700', fontSize:'1.25rem', my:1}}>
                {item.price}
            </Typography>
            <Button variant="contained"
            onClick={handleCheckoutGift}
                  sx={{width:'100%', my:1,display:'flex', alignItems:'center', gap:1, textTransform:'none', color:'rgba(255, 255, 255, 1)', boxShadow:'none', backgroundColor:'rgba(86, 4, 246, 1)', px:2, maxWidth:'fit-content', borderRadius:'100px', ':hover': {
            backgroundColor:'#4f03e7', 
            fontWeight:600,
            boxShadow:'0px 3px 1px -2px rgba(86, 4, 246,0.2),0px 2px 2px 0px rgba(86, 4, 246,0.14),0px 1px 5px 0px rgba(86, 4, 246,0.12)'
          }}}>Order Now</Button>
        </Box>
        {openModal && <AppModal setShowModal={setOpenModal} showModal={true} icon={Delete}  message={messageContent}>
        <Typography variant='h3' sx={{color: 'rgba(18, 18, 18, 1)', fontSize: 20}}>
        Remove Item from favorites
            </Typography>
            <Typography variant='p' sx={{marginTop: 2}}>
            Are you sure you want to delete this item from your favorites list? This action cannot be undone.
            </Typography>
        <Box sx={{display:'flex', flex: 1, alignItems:'center', justifyContent: 'space-between', marginTop: {md: 4, xs: 2},marginBottom: {md: 0, xs: 2}, width: '100%', gap: 6}}>



{/* Add to Favorites Button  */}
<Box sx={{ marginTop: 1,width: 'auto' }}>
 <Button
 onClick={()=>setOpenModal(false)}
   variant="contained"
   color="secondary"
   sx={{
     width: '100%',
     
     padding: {md: '10px 20px', xs: '5px 8px'},
     border: '1px solid #CBB1FC',
     borderRadius: '25px',
    
     textTransform:'capitalize',
     backgroundColor:'rgba(219, 219, 219, 1)',
     color:'rgba(18, 18, 18, 0.7)',
    
  
   }}
 >
  Cancel
 </Button>
</Box>



{pathname.includes('giftshop') ? <Box sx={{ marginTop: 2, width: 'auto'}}>
 <Button
   variant="contained"
   color="success"
   onClick={()=>handleGiftDelete(item?.id)}
   sx={{
     width: '100%',
     padding: {md: '10px 20px', xs: '5px 8px'},
     borderRadius: '25px',
       textTransform:'capitalize',
       backgroundColor:'rgba(254, 86, 86, 1)',
     color:'#fff',
   }}
 >
  Yes, Remove Item
 </Button>
</Box> : <Box sx={{ marginTop: 2, width: 'auto'}}>
 <Button
   variant="contained"
   color="success"
   onClick={()=>handleCourseDelete(item?.courseId)}
   sx={{
     width: '100%',
     padding: {md: '10px 20px', xs: '5px 8px'},
     borderRadius: '25px',
       textTransform:'capitalize',
       backgroundColor:'rgba(254, 86, 86, 1)',
     color:'#fff',
   }}
 >
  Yes, Remove Item
 </Button>
</Box>}
</Box>
            
            </AppModal>}
  
    </Box>
    )
}
}

export default OrderCard